import {
  fetchBalance,
  prepareWriteContract,
  readContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";

import { formatEther, parseEther } from "viem";

//---------------------Write Contract methods----------------------------

export const approveAllowance = async (obj) => {
  const { tokenContract, swapContract, tokenContractAbi, amount } = obj;
  try {
    const config = await prepareWriteContract({
      address: tokenContract,
      abi: tokenContractAbi,
      functionName: "approve",
      args: [swapContract, parseEther(amount)],
    });
    const { hash } = await writeContract(config);
    return hash;
  } catch (error) {
    throw new Error(error);
  }
};

export const swapToken = async (obj) => {
  const { swapContract, tokenContractAbi, amount } = obj;

  try {
    const config = await prepareWriteContract({
      address: swapContract,
      abi: tokenContractAbi,
      functionName: "swapToken",
      args: [parseEther(amount)],
    });
    const { hash } = await writeContract(config);
    return hash;
  } catch (error) {
    throw new Error(error);
  }
};

//---------------------Read Contract methods----------------------------

export const fetchTokenBalance = async (walletAddress, tokenAddress) => {
  const balance = await fetchBalance({
    address: walletAddress,
    token: tokenAddress,
  });
  return balance?.formatted;
};

export const fetchApprovalAllowance = async (obj) => {
  const { tokenContract, swapContract, tokenContractAbi, walletAddress } = obj;

  const allowance = await readContract({
    address: tokenContract,
    abi: tokenContractAbi,
    functionName: "allowance",
    args: [walletAddress, swapContract],
  });
  return formatEther(allowance);
};

export const fetchIsSwappingActive = async (obj) => {
  const {  swapContract, tokenContractAbi } = obj;

  const isSwapping = await readContract({
    address: swapContract,
    abi: tokenContractAbi,
    functionName: "swapStatus",
  });
  return isSwapping;
};

export const fetchVanryTokenBalance = async (obj) => {
  const { vanryContract, vanryAbi, walletAddress } = obj;

  const allowance = await readContract({
    address: vanryContract,
    abi: vanryAbi,
    functionName: "balanceOf",
    args: [walletAddress],
  });
  return formatEther(allowance);
};

export const getWaitTransaction = async (hash) => {
  try {
    const data = await waitForTransaction({
      hash,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
